import 'whatwg-fetch'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import { createProvider, AUTH_TOKEN } from './vue-apollo'
import lodash from 'lodash'
import axios from 'axios'
import Echo from 'laravel-echo'
import i18n from './i18n'

axios.defaults.withCredentials = false;
window.Pusher = require('pusher-js');
window.Echo = new Echo({
  encrypted: false,
  forceTLS: false,
  broadcaster: 'pusher',
  key: process.env.VUE_APP_PUSHER_API_KEY,
  wsHost: process.env.VUE_APP_WEBSOCKET_HOST,
  wsPort: process.env.VUE_APP_WEBSOCKET_PORT,
  wssPort: process.env.VUE_APP_WEBSOCKET_PORT,
  disableStats: true,
  enabledTransports: ['ws', 'wss'],
  authorizer: (channel) => {
    return {
      authorize: (socketId, callback) => {
        axios.post(process.env.VUE_APP_WEBSOCKET_AUTH, {
          socket_id: socketId,
          channel_name: channel.name
        }, {
          headers: {
            authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
          }
        })
        .then(response => {
          callback(false, response.data);
        })
        .catch(error => {
          callback(true, error);
        });
      }
    };
  },
});

Vue.config.productionTip = false

window._ = lodash

// eslint-disable-next-line no-unused-vars
const _ = lodash

Object.defineProperty( Vue.prototype, '_', { value: lodash } );

import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import relativeTime from 'dayjs/plugin/relativeTime'
import updateLocale from 'dayjs/plugin/updateLocale'
import isBetween from 'dayjs/plugin/isBetween'
import duration from 'dayjs/plugin/duration'
dayjs.extend(isBetween)
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(relativeTime)
dayjs.extend(updateLocale)
dayjs.extend(duration)
require('dayjs/locale/de')
dayjs.updateLocale('de', {
  relativeTime: {
    future: "in %s",
    past: "vor %s",
    s: 'wenigen Sekunden',
    m: "einer Minute",
    mm: "%d Minuten",
    h: "einer Stunde",
    hh: "%d Stunden",
    d: "einem Tag",
    dd: "%d Tagen",
    M: "einem Monat",
    MM: "%d Monaten",
    y: "einem Jahr",
    yy: "%d Jahren"
  }
})
dayjs.locale('de')

Object.defineProperty( Vue.prototype, 'moment', { value: dayjs } );

Object.defineProperty( Vue.prototype, '$echo', { value: window.Echo } );

new Vue({
  router,
  store,
  vuetify,
  apolloProvider: createProvider(),
  i18n,
  render: h => h(App)
}).$mount('#app')
